import React from 'react'
import { FiltersPage } from './pages'
import { ApolloProvider, NormalizedCacheObject, InMemoryCache, ApolloClient } from '@apollo/client'
import createApolloClient from './client/apollo'
import { CachePersistor, LocalStorageWrapper } from 'apollo3-cache-persist'

function App() {
  const [client, setClient] = React.useState<ApolloClient<NormalizedCacheObject>>()

  React.useEffect(() => {
    async function init() {
      const cache = new InMemoryCache()
      const newPersistor = new CachePersistor({
        cache,
        storage: new LocalStorageWrapper(window.localStorage),
        debug: true,
        maxSize: false,
      })
      await newPersistor.restore()
      setClient(createApolloClient(cache))
    }

    init().catch(console.error)
  }, [])

  if (!client) {
    return null
  }

  return (
    <ApolloProvider client={client}>
      <FiltersPage />
    </ApolloProvider>
  )
}

export default App
